import lottie from 'lottie-web';
import { nanoid } from 'nanoid';
import { eventBus } from '../utils/event-bus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

export class Lottie {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.options = options;
		this.isEnable = false;

		this.blockID = selector.slice( 1 );
		this.lotties = [];
		this.isPlay = this.options.autoplay;
		this.triggerIDs = [];
	}

	init() {
		if ( ! this.elements.length || this.isEnable ) return;
		this.elements.forEach( ( ele, index ) => {
			const theFile = ele.dataset.lottie;
			const theWrap = ele.querySelector( '.el-inner' );
			const theLottie = lottie.loadAnimation( {
				container: theWrap,
				renderer: this.options.renderer || 'svg',
				loop: this.options.loop || false,
				autoplay: false,
				path: theFile,
			} );
			this.lotties[ index ] = theLottie;
			theLottie.addEventListener( 'data_ready', () => {
				const elementToRemove =
					theWrap.querySelector( '.lottie-loading' );
				if ( elementToRemove ) {
					elementToRemove.remove();
				}
			} );
			this.triggerIDs[ index ] = `lottie-trigger-${ nanoid( 9 ) }`;
			ScrollTrigger.create( {
				trigger: ele,
				id: this.triggerIDs[ index ],
				start: 'top bottom',
				end: 'bottom top',
				onEnter: () => {
					if ( this.isPlay ) this.lotties[ index ].play();
				},
				onLeave: () => {
					if ( this.isPlay ) this.lotties[ index ].pause();
				},
				onEnterBack: () => {
					if ( this.isPlay ) this.lotties[ index ].play();
				},
				onLeaveBack: () => {
					if ( this.isPlay ) this.lotties[ index ].pause();
				},
			} );
		} );
		this.eventTo = eventBus.on(
			`lottie-${ this.blockID }-to`,
			this.#jumpTo.bind( this )
		);
		this.eventPlay = eventBus.on(
			`lottie-${ this.blockID }-play`,
			this.#play.bind( this )
		);
		this.eventPause = eventBus.on(
			`lottie-${ this.blockID }-pause`,
			this.#pause.bind( this )
		);
		this.eventStop = eventBus.on(
			`lottie-${ this.blockID }-stop`,
			this.#stop.bind( this )
		);
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		this.triggerIDs.forEach( ( item ) => {
			ScrollTrigger.getById( item )?.kill( true );
		} );
		this.lotties.forEach( ( el ) => {
			el.destroy();
		} );
		eventBus.off( `lottie-${ this.blockID }-to`, this.eventTo );
		eventBus.off( `lottie-${ this.blockID }-play`, this.eventPlay );
		eventBus.off( `lottie-${ this.blockID }-pause`, this.eventPause );
		eventBus.off( `lottie-${ this.blockID }-stop`, this.eventStop );
		this.triggerIDs = [];
		this.lotties = [];
		this.isPlay = this.options.autoplay;
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.options = null;
		this.isEnable = null;
		this.blockID = null;
		this.lotties = null;
		this.isPlay = null;
		this.triggerIDs = null;
	}

	#jumpTo( targetFrame ) {
		this.lotties.forEach( ( el ) => {
			el.goToAndStop( targetFrame, true );
		} );
	}

	#play() {
		this.lotties.forEach( ( el ) => {
			el.play();
			this.isPlay = true;
		} );
	}
	#pause() {
		this.lotties.forEach( ( el ) => {
			el.pause();
			this.isPlay = false;
		} );
	}
	#stop() {
		this.lotties.forEach( ( el ) => {
			el.stop();
			this.isPlay = false;
		} );
	}
}
